<template>
<div class="item" ref="item">
    <a :href="moreLinkUrl" target="_blank" draggable="false">
        <img :src="img" class="img" :id="`item-${id}`" draggable="false">
    </a>
    <h3 class="title">
        <a
            :href="moreLinkUrl"
            target="_blank"
            :style="{color: titleColor}"
            draggable="false"
            :data-type="title">{{ title }}</a>
        <span class="outline" :style="{backgroundColor: titleColor}"/>
    </h3>

    <template v-for="obj in linkObjs">
        <p :key="obj.url" class="text" >
            <a
                :href="obj.url"
                target="_blank"
                draggable="false"
                :data-type="`${title}-${obj.text}`">{{obj.text}}</a>
        </p>
    </template>
    <div v-html="htmlContent"/>
</div>

</template>
<script>
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get } from 'lodash';
export default {
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    img: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    titleColor: {
      type: String,
      required: true
    },
    linkObjs: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      htmlContent: ''
    };
  },

  computed: {
    moreLinkUrl() {
      var linkObjs = this.linkObjs;
      return get(linkObjs, linkObjs.length - 1 + ".url");
    }

  },

  mounted() {
    this.setImgHoverStyle();
  },

  methods: {
    setImgHoverStyle() {
      this.htmlContent = "\n                <style>\n                    #item-" + this.id + ":hover {\n                        box-shadow: 0px 8px 12px -4px " + this.titleColor + "33;\n                    }\n                </style>\n            ";
    }

  }
};
</script>
<style scoped>
.item {
  position: relative;
}
.item a {
  text-decoration: none;
}
.item .img {
  width: 160px;
  height: 116px;
  position: absolute;
  border-radius: 4px;
  top: 18px;
  transition: top 0.2s;
}
.item .img:hover {
  top: 16px;
  transition: top 0.2s;
}
.item .title {
  margin: 156px 0 14px 0;
  font-size: 20px;
  opacity: 0.8;
  text-align: center;
}
.item .title:hover {
  opacity: 1;
}
.item .title .outline {
  display: block;
  width: 16px;
  height: 3px;
  margin: auto;
  text-align: center;
  margin-top: 4px;
}
.item .text {
  text-align: center;
  margin: 0 0 10px 0;
}
.item .text a {
  font-size: 14px;
  color: #636C78;
}
.item .text a:hover {
  font-weight: 500;
  color: #33383E;
}

</style>
